import type { IconSvgObject } from './types';

const ArrowBigUpDashIcon: IconSvgObject = [
  ["path", { d: "M9 13H5.45377C4.65087 13 4 12.3491 4 11.5462C4 11.1941 4.12781 10.8539 4.3597 10.5889L10.3415 3.75258C10.76 3.27433 11.3645 3 12 3C12.6355 3 13.24 3.27433 13.6585 3.75258L19.6403 10.5889C19.8722 10.8539 20 11.1941 20 11.5462C20 12.3491 19.3491 13 18.5462 13H15V16C15 16.5523 14.5523 17 14 17H10C9.44772 17 9 16.5523 9 16V13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 21H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowBigUpDashIcon;
